module.exports = __webpack_public_path__ + "static/media/COS_MAYOLY_BEAUTERRA.eb637d66.svg";